export default __webpack_public_path__ + "media/images/portfolio/gallery-01-1200x916_original-40ecffea170f8337675508a0578d92b2.jpg";